/**
 * Optional **real NIC MAC** from a native/desktop shell only (Electron preload, etc.).
 * Set `window.__ECLIPERA_HARDWARE_MAC__ = "AA:BB:CC:DD:EE:FF"` — sent as `x-mac-address`.
 *
 * Web browsers cannot read the real MAC; when this is unset, the backend still fills `User.macAddress`
 * using a stable **FE:… pseudo-MAC** derived from `x-device-id` (see `clientInstallId.ts`).
 */
declare global {
  interface Window {
    /** Native-only: real hardware MAC (colon-separated hex). */
    __ECLIPERA_HARDWARE_MAC__?: string
  }
}

const MAC_COLON =
  /^([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2}):([0-9A-Fa-f]{2})$/

export function getHardwareMacForRequest(): string {
  if (typeof window === 'undefined') return ''
  const raw = window.__ECLIPERA_HARDWARE_MAC__
  if (typeof raw !== 'string') return ''
  const m = raw.trim()
  if (!MAC_COLON.test(m)) return ''
  const first = parseInt(m.slice(0, 2), 16)
  if (Number.isNaN(first) || first & 1) return ''
  return m.toUpperCase()
}
